module.exports = __webpack_public_path__ + "media/images/okra-offers/app-screenshot-2-5053e07b2676136627fc7e05b5845b53.png";